module.exports = __webpack_public_path__ + "img/40_38_055_370.8fb34efa.jpg";